import React from "react";
import FormField from "@amzn/awsui-components-react/polaris/form-field";
import Input from "@amzn/awsui-components-react/polaris/input";
import Icon from "@amzn/awsui-components-react/polaris/icon";
import Spinner from "@amzn/awsui-components-react/polaris/spinner";
import Select from "@amzn/awsui-components-react/polaris/select";
import RadioGroup from "@amzn/awsui-components-react/polaris/radio-group";
import Textarea from "@amzn/awsui-components-react/polaris/textarea";
import Checkbox from "@amzn/awsui-components-react/polaris/checkbox";
import {VALIDATE_NODE_PARAMS_API_ENDPOINT} from "src/config"
import {callSNOWDataService} from "src/utils/snowDataServiceWrapper";
import { DatePicker } from "@amzn/awsui-components-react";
import CodeEditor from "@amzn/awsui-components-react-v3/polaris/code-editor";
import ace from "ace-builds/src-noconflict/ace";
import 'ace-builds/webpack-resolver.js';
import { Multiselect } from "@amzn/awsui-components-react-v3";
const { v4: uuidv4 } = require('uuid');

/**
 * Returns SNOWAttribute component
 * @param attribute
 * @returns
 */
export function getSNOWAttribute(attribute) {
    return React.createElement(SNOWAttribute,
        {
            id: attribute.id,
            key : attribute.id,
            name: attribute.name,
            description: attribute.description,
            hintText: attribute.hintText,
            type: attribute.type,
            value: attribute.value,
            validations: attribute.validations,
            regEx: attribute.regEx,
            options: attribute.options,
            mandatory: attribute.mandatory,
            placeholder: attribute.placeholder,
            disabled: attribute.disabled,
            onValidationCompletion: attribute.onValidationCompletion,
            errorText: attribute.errorText
        }
    )
}

/**
 * This is a React Component that can be used for creating a SNOW Attribute structure
 * It provides some of the generic features like
 *      Validating if the attribute value follows a RegEx
 *      Making a call to SNOW ValidateEntityParameter API for validating the data
 */
export default class SNOWAttribute extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: null,
            preferences: undefined,
            validationResult: null
        }

        this.handlePreferenceChange = this.handlePreferenceChange.bind(this)
        this.handleAttributeValueChange = this.handleAttributeValueChange.bind(this)
        this.isRegExSuccessful = this.isRegExSuccessful.bind(this)
        this.isValidationSuccessful = this.isValidationSuccessful.bind(this)
        this.isDataInvalid = this.isDataInvalid.bind(this)
        this.getErrorText = this.getErrorText.bind(this);

    }

    render() {
        let inputDiv;
        switch(this.props.type) {
            case "text":
                inputDiv = <Input type={"text"} value={this.props.value || this.state.value} 
                                    placeholder={this.props.placeholder}
                                    onChange={this.handleAttributeValueChange} 
                                    disabled={this.props.disabled}
                                />
                break;
            case "textarea":
                inputDiv = <Textarea type={"textarea"} value={this.props.value || this.state.value} 
                                    placeholder={this.props.placeholder}
                                    onChange={this.handleAttributeValueChange} 
                                    disabled={this.props.disabled}
                                />
              break;
            case "select":
                inputDiv = <Select options={this.props.options} 
                                    selectedLabel="Selected" 
                                    placeholder={this.props.placeholder}
                                    selectedOption={this.props.value || this.state.value} 
                                    filteringType={this.props.filteringType}
                                    disabled={this.props.disabled}
                                    onChange={this.props.overrideHandler ? this.props.overrideHandler : this.handleAttributeValueChange}
                                />
                break;
             case "radio":
                    inputDiv = <RadioGroup value={this.props.value || this.state.value} 
                                    items={this.props.options}
                                    onChange={this.handleAttributeValueChange}
                                />
                break;
            case "multiselect":
                    inputDiv = <Multiselect
                                    filteringType="auto"
                                    options={this.props.options}
                                    disabled={this.props.disabled}
                                    placeholder={this.props.placeholder}
                                    onChange={this.handleAttributeValueChange}
                                    selectedLabel="Selected"
                                    selectedOptions={this.state.value ? this.state.value : this.props.value}
                                    virtualScroll={this.props.virtualScroll || false}
                                />
                break;
            case "date":
                    inputDiv = <DatePicker
                                    onChange={this.handleAttributeValueChange}
                                    value={this.props.value || futureDate().toISOString().split('T')[0]}
                                    nextMonthAriaLabel="Next month"
                                    isDateEnabled={date => isDateEnabled(date)}
                                    previousMonthAriaLabel="Previous month"
                                    todayAriaLabel="Today"
                                />
                break;   
            case "checkbox":
                    inputDiv = <Checkbox
                                    onChange={this.handleAttributeValueChange}
                                    checked={this.props.value || false} 
                                    disabled = {this.props.disabled} 
                                >
                                {this.props.placeholder}
                                </Checkbox>
                break;      
            case "code":
                    inputDiv = <CodeEditor
                                    ace={ace}
                                    language="json"
                                    value={this.props.value || "[]"}
                                    preferences={this.state.preferences}
                                    onPreferencesChange={this.handlePreferenceChange}
                                    loading={false}
                                    onChange={this.handleAttributeValueChange}
                                    i18nStrings={{
                                    loadingState: "Loading code editor",
                                    errorState: "There was an error loading the code editor.",
                                    errorStateRecovery: "Retry",
                                    editorGroupAriaLabel: "Code editor",
                                    statusBarGroupAriaLabel: "Status bar",
                                    cursorPosition: (row, column) =>
                                    `Ln ${row}, Col ${column}`,
                                    errorsTab: "Errors",
                                    warningsTab: "Warnings",
                                    preferencesButtonAriaLabel: "Preferences",
                                    paneCloseButtonAriaLabel: "Close",
                                    preferencesModalHeader: "Preferences",
                                    preferencesModalCancel: "Cancel",
                                    preferencesModalConfirm: "Confirm",
                                    preferencesModalWrapLines: "Wrap lines",
                                    preferencesModalTheme: "Theme",
                                    preferencesModalLightThemes: "Light themes",
                                    preferencesModalDarkThemes: "Dark themes"
                                    }}
                                />
                break;                                        
          } 

        const isDateEnabled = (date) => {
            return date > futureDate();
        }

        function futureDate() {
            const currentDate = new Date()
            return new Date(currentDate.setDate(currentDate.getDate() + 15))
        }

        return (
            <div>
                <div data-awsui-column-layout-root="true">
                    <FormField label= {
                                        this.props.mandatory? <div>{this.props.name}<span style={{color: 'red'}}>*</span></div> : <div>{this.props.name}</div> 
                                    }
                               description={this.props.description}
                               hintText={this.state.validationResult || this.props.hintText}
                               errorText={this.state.errorText || this.props.errorText}>
                        {inputDiv}
                    </FormField>
                </div>
            </div>
        )
    }

    /**
     * This method takes care of the Change events in the Form Fields
     * Does the RegEx check if there's any regex passed for the field
     * Does the API Call Validation if there's any validation required
     * Set's the state in the Parent Component by making use of a callback function.
     *      - TODO : This can be replaced when we move to Redux
     *
     * @param event
     * @returns {Promise<void>}
     */
    async handleAttributeValueChange(event) {

        let value;
        if (this.props.type === "text" || this.props.type === "radio" || this.props.type === "date" || this.props.type === "code" || this.props.type === "textarea") {
            value = event.detail.value;
        } else if (this.props.type === "select") {
            value = event.detail.selectedOption;
        } else if (this.props.type === "checkbox") {
            value = event.detail.checked;
        }else {
            value = event.detail.selectedOptions;
        }

        if (this.isRegExSuccessful(value) && await this.isValidationSuccessful(value)) {

            this.setState({
                value: value,
                errorText: null,
            });
            this.props.onValidationCompletion({id: this.props.id, status: true, value: value, isLoadingNextStep: false});
        } else {
            this.props.onValidationCompletion({id: this.props.id, status: false, isLoadingNextStep: true});
        }
    }

    async handlePreferenceChange(event) {
        this.setState({
            preferences: event.detail
        });  
    }

    /**
     * Validates a given field value against the RegEx based on Schema
     * @param value - attribute value to be Validated
     * @returns {boolean} true if the value follows the RegEx
     */
    isRegExSuccessful(value) {
        this.setState({
            errorText: null
        });

        const regexLiteral = this.props.regEx;
        if (regexLiteral && !regexLiteral.test(value)) {
            this.setState({
                errorText: "RegEx Validation Failed, refer example !",
                validationResult: null
            })
            return false;
        }
        return true;
    }

    /**
     * Validates a given field value by making respective API Call
     * @param value - attribute value to be Validated
     * @returns {boolean} true if the validation is successful
     */
    async isValidationSuccessful(value) {
        return !(this.props.validations && Object.keys(this.props.validations).length > 0 && await this.isDataInvalid(value));
    }

    /**
     * Handles the Validate Node parameter API Call & set's the state respectively
     * @param value - attribute value to be Validated
     * @returns {Promise<boolean>}
     * // TODO : This logic only works for validation on node name value. We need to figure out how we can pass the node name along with the value on which the validation is to be performed.
     */
    async isDataInvalid(value) {
        this.setState({
            validationResult: <span className="awsui-util-status-inactive"><Spinner/> Validating..</span>
        });

        if(this.props.validations.hasOwnProperty('validateCB')){
            let validationResponse = await this.props.validations['validateCB']({value: value})
            if(!validationResponse.isValid){
                this.setState({
                    errorText: validationResponse.errorText,
                    validationResult: null
                })
                return true;
            }    
        }

        try {
            let apiResponse = await callSNOWDataService({
                path: '/validateNodeParameters',
                method: 'POST',
                body: {
                    nodeParameters: {node_name: value, node_type: this.props.nodeType},
                    validationTypes: this.props.validations,
                    requestId: uuidv4()
                },
                url: VALIDATE_NODE_PARAMS_API_ENDPOINT,
            });
            apiResponse = JSON.parse(apiResponse.output)
            if(apiResponse.isValid) {
                this.setState({
                    validationResult: <span className="awsui-util-status-positive"><Icon
                        name="status-positive"/> Validated </span>
                });
                return false;
            } else {
                this.setState({
                    errorText: this.getErrorText(apiResponse.errorMessages),
                    validationResult: null
                })
                return true;
            }

        } catch (e) {
            this.setState({
                errorText: "Unknown exception occurred while performing validation. Please cut a SIM to SNOW Team to debug this issue.",
                validationResult: null
            })
            return true;
        }
    }

    getErrorText(errorMessages) {
        let errorList = errorMessages.map(errorMessage =>
        <li key = {errorMessage.validationType}> {errorMessage.validationType + " = " + errorMessage.toCheck + " validation failed with error - " + errorMessage.errorMessage} </li>
        )
        return <ol> {errorList} </ol>;
    }
}

SNOWAttribute.defaultProps = {
    disabled : false
}
